var _defs, _rect, _circle, _circle2, _g, _g2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomSystemsDarkBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1867 913",
    role: "presentation",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "blue"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#087CFF",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#087CFF",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "pink"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF2775",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FF2775",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2775",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 42,
    height: 42,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 0H0V42",
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.04,
    strokeWidth: 0.8
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1867,
    height: 913,
    fill: "url(#grid)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1426,
    cy: 317,
    r: 455,
    fill: "url(#blue)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1615,
    cy: 405,
    r: 365,
    fill: "url(#pink)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.15,
    transform: "translate(1444 310)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 410,
    ry: 300
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 333,
    ry: 244
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 258,
    ry: 189,
    strokeDasharray: "3 9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FF2775",
    strokeOpacity: 0.12,
    transform: "translate(1514 388)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 220,
    ry: 164
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 168,
    ry: 125,
    strokeDasharray: "3 8"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1768,
    cy: 132,
    r: 3.5,
    fill: "#FF2775"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomSystemsDarkBackground);
export default __webpack_public_path__ + "static/media/custom-systems-dark-background.3949aff51273e1f00d2138a57d845b36.svg";
export { ForwardRef as ReactComponent };